import React from 'react';
import { connect } from 'react-redux';
import EmptyPage from './Empty';
import HomeResumo from './analytics/components/HomeResumo';

const HomeGate = ({ menuRotes }) => {
  if (menuRotes && menuRotes.ANALYTICS) {
    return <HomeResumo />;
  }
  return <EmptyPage />;
};

const mapStateToProps = state => ({
  menuRotes: state.admMenus && state.admMenus.admMenuRoutes,
});

export default connect(mapStateToProps)(HomeGate);
